import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";
import { registerUser } from "../api/auth";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    username: "",
    phone: "",
    full_name: "",
    password: "",
    confirm_password: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
    if (field === "password" || field === "confirm_password") {
      if (
        (field === "password" && form.confirm_password && value !== form.confirm_password) ||
        (field === "confirm_password" && form.password && value !== form.password)
      ) {
        setPasswordError("رمز عبور و تکرار آن یکسان نیست.");
      } else {
        setPasswordError("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.password || !form.confirm_password) {
      setPasswordError("رمز عبور و تکرار آن را وارد کنید.");
      return;
    }
    if (form.password !== form.confirm_password) {
      setPasswordError("رمز عبور و تکرار آن یکسان نیست.");
      return;
    }
    setPasswordError("");
    setError("");
    setLoading(true);
    try {
      const result = await registerUser({
        email: form.email,
        username: form.username,
        phone: form.phone,
        full_name: form.full_name,
        password: form.password,
      });
      navigate("/verify-code", {
        state: {
          email: form.email,
          expiresInSeconds: result?.expires_in_seconds,
          sentAt: Date.now(),
        },
      });
    } catch (err) {
      setError(err.message || "خطا در ثبت‌نام. لطفا دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="touch-wrapper" dir="rtl">
      {error && (
        <div className="touch-toast">
          <div>
            <div className="touch-toast-title">خطا در ثبت‌نام</div>
            <p className="touch-toast-body">{error}</p>
          </div>
        </div>
      )}
      <div className="touch-left">
        <div className="touch-logo-wrapper">
          <img
            src="/images/touch-prop-logo.png"
            alt="Touch Prop Logo"
            className="touch-logo"
          />
        </div>

        <div className="touch-register-container">
          <form className="touch-register-card" onSubmit={handleSubmit}>
            <h1 className="touch-register-title">ثبت‌نام در تاچ پراپ</h1>
            <p className="touch-register-subtitle">
              اطلاعات خود را وارد کن تا حساب کاربری‌ات ساخته شود.
            </p>

            <div className="touch-input-card touch-register-input-card">
              <input
                type="email"
                className="touch-input"
                placeholder="ایمیل"
                value={form.email}
                onChange={handleChange("email")}
                required
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <span className="touch-input-icon-text">@</span>
              </div>
            </div>

            <div className="touch-input-card touch-register-input-card">
              <input
                type="text"
                className="touch-input"
                placeholder="نام کاربری"
                value={form.username}
                onChange={handleChange("username")}
                required
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path
                    d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-7 2-7 4v1h14v-1c0-2-3-4-7-4z"
                    fill="#444"
                  />
                </svg>
              </div>
            </div>

            <div className="touch-input-card touch-register-input-card">
              <input
                type="tel"
                className="touch-input"
                placeholder="شماره موبایل"
                value={form.phone}
                onChange={handleChange("phone")}
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path
                    d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.36 11.36 0 0 0 3.56.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.56 1 1 0 0 1-.25 1z"
                    fill="#444"
                  />
                </svg>
              </div>
            </div>

            <div className="touch-input-card touch-register-input-card">
              <input
                type="text"
                className="touch-input"
                placeholder="نام و نام خانوادگی (اختیاری)"
                value={form.full_name}
                onChange={handleChange("full_name")}
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path
                    d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-7 2-7 4v1h14v-1c0-2-3-4-7-4z"
                    fill="#444"
                  />
                </svg>
              </div>
            </div>

            <div className="touch-input-card touch-register-input-card">
              <input
                type={showPassword ? "text" : "password"}
                className="touch-input"
                placeholder="رمز عبور"
                value={form.password}
                onChange={handleChange("password")}
                required
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <button
                  type="button"
                  className="touch-eye-btn"
                  onClick={() => setShowPassword((p) => !p)}
                  aria-label="نمایش رمز"
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                        stroke="#444"
                        strokeWidth="1.5"
                      />
                      <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                      <path d="M5 5l14 14" stroke="#444" strokeWidth="1.5" />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                        stroke="#444"
                        strokeWidth="1.5"
                      />
                      <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="touch-input-card touch-register-input-card">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="touch-input"
                placeholder="تکرار رمز عبور"
                value={form.confirm_password}
                onChange={handleChange("confirm_password")}
                required
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <button
                  type="button"
                  className="touch-eye-btn"
                  onClick={() => setShowConfirmPassword((p) => !p)}
                  aria-label="نمایش تکرار رمز"
                >
                  {showConfirmPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                        stroke="#444"
                        strokeWidth="1.5"
                      />
                      <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                      <path d="M5 5l14 14" stroke="#444" strokeWidth="1.5" />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3.1 12.5C4.6 8.6 8 6 12 6c4 0 7.4 2.6 8.9 6.5a.9.9 0 0 1 0 .7C19.4 17.4 16 20 12 20c-4 0-7.4-2.6-8.9-6.5a.9.9 0 0 1 0-.7Z"
                        stroke="#444"
                        strokeWidth="1.5"
                      />
                      <circle cx="12" cy="13" r="3" stroke="#444" strokeWidth="1.5" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {passwordError && (
              <p className="touch-password-error">{passwordError}</p>
            )}

            <button
              type="submit"
              className="touch-primary-btn touch-register-btn"
              disabled={loading}
            >
              {loading ? "در حال ثبت‌نام..." : "ثبت‌نام و ادامه"}
            </button>
          </form>

          <button
            type="button"
            className="touch-back-link"
            onClick={() => navigate("/login")}
          >
            <span className="touch-back-icon">{"<"}</span>
            بازگشت به ورود
          </button>
        </div>
      </div>

      <div className="touch-right">
        <img
          src="/images/fingerprint-pattern.png"
          alt="Fingerprint"
          className="touch-fingerprint"
        />
        <div className="touch-right-overlay">
          <div className="touch-hero-text">
            <h2 className="touch-hero-title">تاچ پراپ ، لمس ثروت بی کران</h2>
            <p className="touch-hero-body">
              مسیر معامله‌گری هوشمند از همین‌جا شروع می‌شه
            </p>
            <div className="touch-dots">
              <span className="touch-dot touch-dot-active" />
              <span className="touch-dot" />
              <span className="touch-dot" />
              <span className="touch-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
